import { SCOUT_TEMPLATE_MODES } from '../../Scout.constants';

export const TOAST_MESSAGES = {
  [SCOUT_TEMPLATE_MODES.SAVE_AS]: {
    title: 'Filter set added',
    message: 'Your filter set has been created successfully',
  },
  [SCOUT_TEMPLATE_MODES.EDIT]: {
    title: 'Filter set updated',
    message: 'Your filter set has been updated successfully',
  },
  [SCOUT_TEMPLATE_MODES.QUICK]: {
    title: 'Filter set updated',
    message: 'Your filter set has been updated successfully',
  },
  [SCOUT_TEMPLATE_MODES.DELETE]: {
    title: 'Filter set deleted',
    message: 'Your filter set has been deleted successfully',
  },
};
